module.exports = __webpack_public_path__ + "9786b249a22787454466b739dffff5a7.svg";